import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { TranslocoDirective } from '@jsverse/transloco';

import { AdvertisementListItemDto, CategoryDto } from '../../api';
import { CachedCategoriesService } from '../../shared/cached-categories.service';
import { AdvertisementChipsComponent } from '../advertisement-chips/advertisement-chips.component';
import { AdvertisementPriceComponent } from '../advertisement-price/advertisement-price.component';

@Component({
  selector: 'app-advertisement-card',
  imports: [
    AdvertisementChipsComponent,
    AdvertisementPriceComponent,
    MatCardModule,
    MatChipsModule,
    TranslocoDirective,
  ],
  templateUrl: './advertisement-card.component.html',
  styleUrl: './advertisement-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvertisementCardComponent {
  ad = input.required<AdvertisementListItemDto>();
  categories = input.required<Map<number, CategoryDto>>();
  private categoriesService = inject(CachedCategoriesService);
  imageUrl: Signal<{ url: string; isSectorImage: boolean }> = computed(() => {
    const ad = this.ad();
    const url = ad.cover_media?.url;
    if (!url) {
      return this.categoriesService.getCategoryImage(ad.category_id);
    }
    return { url, isSectorImage: false };
  });
}
